export enum SyncStatus {
  OUT_OF_SYNC = 'OUT_OF_SYNC',
  SYNCED = 'SYNCED',
  IMPORTED = 'IMPORTED',
  SYNC_FAILED = 'SYNC_FAILED',
  SYNCING = 'SYNCING',
}
